import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchPurInwardData } from '../../Store/PHPSlice/Inward/PurchaseInward';
import { selectPIData } from '../Selectors/Master/ItemSelectors';
import { Grid, Paper } from '@mui/material';
import { BallotOutlined } from '@mui/icons-material';

const PIView = () => {
    const { Id } = useParams();
    const [purData, setPurData] = useState([]);
    const pidata = useSelector(selectPIData);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchPurInwardData(Id));
    }, []);

    const handleViewClick = (form) => {
        // Construct the URL with query parameters or use a placeholder route
        const url = `/BaleLumpView?form=${encodeURIComponent(JSON.stringify(form))}`;

        // Open the URL in a new tab
        window.open(url, '_blank', 'width=900,height=600,scrollbars=yes,resizable=yes');
    };
    // console.log(pidata);
    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1% 0%', width: '100%' }}>

                        <h3 className='centered-heading'>Purchase Inward Cloth View</h3>
                        <div className="dashed-line"></div>

                        {pidata?.data.length > 0 && (
                            pidata?.data?.map((val, valIndex) => (
                                <>
                                    <table style={{ margin: '1% 5%', fontSize: '15px' }} key={valIndex}>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: '200px' }}>Cloth:</td>
                                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{val.clothNm}</td>
                                                <td style={{ width: '200px', paddingLeft: '2%' }}>Mtr.:</td>
                                                <td style={{ padding: ' 0.2% 1%', width: '150px' }} className='dark-color'>{val.mtr}</td>
                                            </tr>

                                            <tr>
                                                <td style={{ width: '200px' }}>Rate:</td>
                                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{val.rate}</td>
                                                <td style={{ width: '200px', paddingLeft: '2%' }}>Amt:</td>
                                                <td style={{ padding: ' 0.2% 1%', width: '150px' }} className='dark-color'>{val.tot}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ width: '200px' }}>GST:</td>
                                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{val.GST}</td>
                                                <td style={{ width: '200px', paddingLeft: '2%' }}>Net Amt.:</td>
                                                <td style={{ padding: ' 0.2% 1%', width: '150px' }} className='dark-color'>{val.netAmt}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ width: '200px' }}>Bale & Lump Details:</td>
                                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>
                                                    <button type='button' className="lump-btn" onClick={() => handleViewClick(val.bale)}> View</button>
                                                </td>
                                                {/* <td style={{ width: '200px', paddingLeft: '2%' }}>Net Amt.:</td>
                                                <td style={{ padding: ' 0.2% 1%', width: '150px' }} className='dark-color'>{val.netAmt}</td> */}
                                            </tr>
                                        </tbody>
                                    </table>
                                    {/* <table>
                                        <thead>
                                            <th>Sr.No.</th>
                                            <th>Bale</th>
                                            <th>Mtr.</th>
                                            <th>Rack</th>
                                            <th>Lump</th>
                                        </thead>
                                        <tbody>
                                            {val.bale.map((bal, balIndex) => (
                                                <tr key={balIndex}>
                                                    <td>{balIndex + 1}</td>
                                                    <td>{bal.bale}</td>
                                                    <td>{bal.mtr}</td>
                                                    <td>{bal.rack}</td>
                                                    <td>
                                                        <button type='button'>Lump</button>
                                                    </td>
                                                </tr>

                                            ))}
                                        </tbody>
                                    </table> */}

                                </>
                            ))

                        )}


                    </div>

                </Paper>
            </Grid>
        </>
    );
}

export default PIView;
